import styled from 'styled-components'
import type { Props } from './ImageGallery'
import * as _ from 'styles/helpers'

const GRID_GAP = 12
const GRID_GAP_MOBILE = 32

const StyledImageGallery = styled.div<Partial<Props>>`
	max-width: ${_.rem(1080)};
	margin: 0 auto;

	ul {
		@media ${_.MQ.before_nav} {
			grid-gap: ${_.rem(GRID_GAP_MOBILE)};
			grid-template-columns: repeat(2, 1fr);
		}

		${_.MIXINS.ul_reset};
		display: grid;
		grid-gap: ${_.rem(GRID_GAP)};
		grid-template-columns: repeat(4, 1fr);
	}

	.LocationImage {
		position: relative;
		background-color: #e2e8f0;
		border-radius: 15px;
		padding: 10;

		// .LocationImage--video
		&--video {
			height: 0;
			padding-top: 75%;
		}

		// .LocationImage__video
		&__video {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			height: 90%;
			width: 90%;
			/* object-fit: cover; */
		}

		// .LocationImage__img
		&__img {
			height: 0;
			padding-top: 75%;
			background-size: cover;
			background-position: center center;
			/* border-radius: 15px; */
			border-radius: ${_.rem(_.BASE_BORDER_RADIUS)};
		}

		&:hover .LocationImage__img {
			cursor: pointer;
			color: cornflowerblue;
		}

		// .LocationImage__delete-button
		&__delete-button {
			position: absolute;
			top: ${_.rem(GRID_GAP)};
			right: ${_.rem(GRID_GAP)};
			width: ${_.rem(44)};
			height: ${_.rem(44)};
			font-size: ${_.rem(20)};
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			color: ${_.COLORS.white};
			background-color: ${_.COLORS.danger};
			border: none;
			border-radius: ${_.rem(_.BASE_BORDER_RADIUS)};
			cursor: pointer;
			-webkit-tap-highlight-color: transparent;

			/* Always visible on mobile/touch devices */
			@media ${_.MQ.before_nav} {
				opacity: 0.9;
			}

			/* Hidden by default on desktop, shown on hover/focus */
			@media ${_.MQ.nav} {
				opacity: 0;
				transition: opacity 0.2s ease-in-out;
			}

			&:focus {
				opacity: 1;
			}

			&:active {
				opacity: 0.7;
			}
		}

		/* Show delete button on hover for desktop */
		&:hover .LocationImage__delete-button {
			@media ${_.MQ.nav} {
				opacity: 1;
			}
		}
	}
`

export default StyledImageGallery
